(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("5RvcM", function(module, exports) {

var $e3qbH = parcelRequire("e3qbH");
const $444a1bb032615f24$var$events = [
    "blur",
    "input",
    "change"
];
const $444a1bb032615f24$var$inputsSelector = "input, select, textarea";
const $444a1bb032615f24$var$inputsWrappersSelector = ".f-text, .f-single-select, .f-checkbox, .f-file, .f-textarea, .f-switch";
const $444a1bb032615f24$var$validateInput = (input)=>{
    const isValid = input.checkValidity();
    const message = $444a1bb032615f24$var$getValidationMessage(input);
    const inputWrapper = input.closest($444a1bb032615f24$var$inputsWrappersSelector);
    inputWrapper?.classList.toggle("--invalid", !isValid);
    const error = new (0, $e3qbH.errorField)(inputWrapper?.querySelector(".f-error") ?? null);
    error.toggle(!isValid);
    error.setTitle(message);
    isValid ? input.setAttribute("aria-invalid", "false") : input.setAttribute("aria-invalid", "true");
};
const $444a1bb032615f24$var$handleInputEvents = (input)=>{
    $444a1bb032615f24$var$events.forEach((event)=>{
        input.addEventListener(event, ()=>{
            $444a1bb032615f24$var$validateInput(input);
        });
    });
};
const $444a1bb032615f24$var$getValidationMessage = (input)=>{
    const { validity: validity, dataset: dataset } = input;
    let message = input.validationMessage;
    // This could be expanded for any validity type and change message.
    // Since I doubt this will be ever used, I will just leave it only for patternMismatch.
    // But feel free to expand this.
    if (validity.patternMismatch && dataset.validityPatternMismatch) message = dataset.validityPatternMismatch;
    if (validity.valueMissing && dataset.validityValueMissing) message = dataset.validityValueMissing;
    return message;
};
const $444a1bb032615f24$var$handleFormSubmit = (form)=>{
    form.addEventListener("submit", (event)=>{
        const inputs = form.querySelectorAll($444a1bb032615f24$var$inputsSelector);
        const isValid = form.checkValidity();
        inputs.forEach((input)=>$444a1bb032615f24$var$validateInput(input));
        if (!isValid) event.preventDefault();
    });
};
const $444a1bb032615f24$var$initForms = ()=>{
    const formsSelector = "form.--validate:not(.--initialized)";
    const forms = document.querySelectorAll(formsSelector);
    forms.forEach((form)=>{
        /**
         * Setting noValidate turns off the native client-side validation,
         * freeing us up to do whatever we want. Turning off validation with JavaScript ensures
         * the default validation still runs if JavaScript never executes for whatever reason.
         * It also prevents showing our invalid style preemptively.
         */ form.noValidate = true;
        const inputs = form.querySelectorAll($444a1bb032615f24$var$inputsSelector);
        inputs.forEach($444a1bb032615f24$var$handleInputEvents);
        $444a1bb032615f24$var$handleFormSubmit(form);
        form.classList.add("--initialized");
    });
};
$444a1bb032615f24$var$initForms();
document.addEventListener("baseformReinit", $444a1bb032615f24$var$initForms);

});
parcelRegister("e3qbH", function(module, exports) {

$parcel$export(module.exports, "errorField", function () { return $a3b5a8db91693d32$export$abf870288a102319; });
class $a3b5a8db91693d32$export$abf870288a102319 {
    errorItem;
    title;
    constructor(errorItem){
        this.errorItem = errorItem;
        this.title = errorItem?.querySelector(".f-error__title") ?? null;
    }
    toggle(show) {
        this.errorItem?.classList.toggle("--show", show);
    }
    setTitle(title) {
        if (this.title) this.title.innerHTML = title;
    }
}

});


})();
//# sourceMappingURL=base-form.0764bc59.js.map
